/* eslint-disable id-length */
import { ptsToInch } from "../../../helpers";
import { headerColor, kpmgBlueLight } from "../../constants";

export const sidebarWidth = ptsToInch(189);
export const fullHeight = ptsToInch(476);
export const leftOffset = ptsToInch(40);
export const topOffset = ptsToInch(30);
export const avatarSize = ptsToInch(89);
export const spacing = ptsToInch(10);
export const bodyWidth = ptsToInch(698);

const header1Options = { breakLine: true, color: headerColor, fontSize: 24, bold: true, lineSpacing: 22 };
export const header2Options = {
  margin: 0,
  valign: "top",
  fontFace: "Arial",
  color: headerColor,
  fontSize: 12,
  lineSpacing: 12,
  bold: true,
  breakLine: true
};
export const header3Options = {
  ...header2Options,
  color: "#000000",
  fontSize: 10,
  lineSpacing: 10
};
export const textOptions = { color: "#000000", fontSize: 10, breakLine: true, lineSpacing: 10 };

export const avatarOptions = { x: leftOffset, y: topOffset, w: avatarSize, h: avatarSize };
export const bodyOptions = {
  valign: "top",
  fontFace: "Arial",
  x: leftOffset + sidebarWidth + ptsToInch(10),
  y: topOffset,
  w: ptsToInch(698),
  h: fullHeight
};
export const footerOptions = {
  x: leftOffset + sidebarWidth,
  y: topOffset + fullHeight,
  w: ptsToInch(664),
  h: ptsToInch(34),
  sizing: { type: "contain" }
};
export const sidebarOptions = {
  x: leftOffset,
  y: topOffset,
  w: sidebarWidth,
  h: fullHeight,
  fill: { color: "#F2F2F2" }
};
export const getSidePanelDetailsOptions = (showAvatar: boolean) => ({
  x: leftOffset,
  y: showAvatar ? topOffset + avatarSize + spacing : topOffset,
  w: sidebarWidth,
  h: fullHeight - (showAvatar ? avatarSize : 0),
  valign: "top",
  fontFace: "Arial"
});
export const nameOptions = {
  margin: 0,
  valign: "top",
  align: "left",
  fontFace: "Arial",
  ...header1Options
};
export const contactOptions = {
  breakLine: true,
  color: kpmgBlueLight,
  fontSize: 10,
  bold: true,
  underline: { color: kpmgBlueLight, style: "sng" }
};
export const customLogoOptions = {
  x: leftOffset,
  y: topOffset + fullHeight,
  w: ptsToInch(33),
  h: ptsToInch(33)
};
export const defaultLogoOptions = {
  x: leftOffset,
  y: topOffset + fullHeight,
  w: ptsToInch(100),
  h: ptsToInch(30)
};
export const categoryOptions = { ...header2Options, color: kpmgBlueLight, fontSize: 10, bold: true };
export const categoryPositionOptions = { breakLine: true, color: "#000000", fontSize: 10, bold: true };
